function isTextChild(child) {
    return child.type === "text";
}
function isComponent(meta) {
    if (meta &&
        meta.type &&
        meta.package)
        return true;
    else
        return false;
}
function isC2ContainerComponent(meta) {
    return isComponent(meta) &&
        (meta.type === "C2Container" || meta.type === "C2Columns" || meta.type === "C2Column") &&
        meta.package === "code2";
}
function isColumnsComponent(meta) {
    return isComponent(meta) &&
        meta.type === "C2Columns" &&
        meta.package === "code2";
}
function isColumnComponent(meta) {
    return isComponent(meta) &&
        meta.type === "C2Column" &&
        meta.package === "code2";
}
function isC2RootContainerComponent(meta) {
    return isComponent(meta) &&
        meta.type === "C2RootContainer" &&
        meta.package === "code2";
}
function isRootComponent(meta, componentList) {
    return isComponent(meta) &&
        ((meta.type === "C2RootContainer" &&
            meta.package === "code2") ||
            (meta.type === "C2Columns" && meta.id === "container") ||
            (meta.type === "C2Column" && meta.parentId === "container" && componentList[meta.parentId].children.length === 1) ||
            meta.type === "GridContainer");
}

export { isC2ContainerComponent, isC2RootContainerComponent, isColumnComponent, isColumnsComponent, isComponent, isRootComponent, isTextChild };
//# sourceMappingURL=SmartLayoutUtils.js.map
